import { Component, EventEmitter, Input, OnInit, ViewChild, signal } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs';
import {
  LeaProfessionalDevelopmentClient,
  SimpleSelectOptionDto,
  UpdateProfessionalDevelopmentRecordCommand,
} from 'src/shared/services/api.service';
import { catchValidationErrors } from 'src/shared/utilities/validator-utilities';

@Component({
  selector: 'cert-update-pd-modal',
  standalone: false,
  templateUrl: './update-pd-modal.component.html',
})
export class UpdateProfessionalDevelopmentModalComponent implements OnInit {
  @Input() selectionCount = 0;
  @Input() leaCodeId!: number;
  @Input() professionalDevelopmentRecordIds: number[] = [];
  @Input() initialDescription: string | undefined = undefined;
  @Input() initialHours: number | undefined = undefined;
  @Input() initialCompletionDate: Date | undefined = undefined;
  @Input() initialProfessionalDevelopmentTypeCodeId: number | undefined = undefined;
  @Input() professionalDevelopmentTypeOptions: SimpleSelectOptionDto[] = [];
  @ViewChild('awardForm') form!: NgForm;
  updateProfessionalDevelopmentRecordCommand!: UpdateProfessionalDevelopmentRecordCommand;
  submitting = signal(false);

  errorEmitter = new EventEmitter<any>();

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly professionalDevelopmentClient: LeaProfessionalDevelopmentClient,
  ) {}

  ngOnInit() {
    this.updateProfessionalDevelopmentRecordCommand = {
      leaCodeId: this.leaCodeId,
      professionalDevelopmentRecordIds: this.professionalDevelopmentRecordIds,
      description: this.initialDescription,
      hours: this.initialHours,
      completionDate: this.initialCompletionDate,
      professionalDevelopmentTypeCodeId: this.initialProfessionalDevelopmentTypeCodeId,
    };
  }

  confirm() {
    this.submitting.set(true);
    this.professionalDevelopmentClient
      .updateProfessionalDevelopmentRecords(this.updateProfessionalDevelopmentRecordCommand)
      .pipe(
        catchValidationErrors(this.form, this.errorEmitter),
        finalize(() => this.submitting.set(false)),
      )
      .subscribe({
        next: () => this.activeModal.close(true),
      });
  }

  dismiss() {
    this.activeModal.dismiss();
  }
}
